import request from 'request-promise';
import Template from 'template';
import getBootstrapDevice from 'get-bootstrap-device';

const searchSuggestions = () =>
{
	/*
	<script type="text/html" data-template="suggestionContainer">
		<div class="searchSuggestions">
			
		</div>
	</script>
	<script type="text/html" data-template="suggestionRow">
		<div class="searchSuggestion{{classes}}">
			{{{label}}}
		</div>
	</script>
	*/
	
	var lastMillis = null;
	const getRelativeMillis = () =>
	{
		const currentMillis = (new Date()).getTime();
		
		if(lastMillis === null) lastMillis = currentMillis;
		
		const offset = '+'+(currentMillis-lastMillis);
		
		lastMillis = currentMillis;
		
		return offset;
	};
	
	//following is a imitation of the suggestions "jquery-ui suggestions" provides, thats the reason for the hardcoded html, classes & id's
	var debug = false;
	window.enableSuggestionDebugging = (enable) =>
	{
		debug = enable || true;
	};
	
	const suggestionsEnabled = true;
	const suggestionsShownSelector = 'div.searchSuggestions';
	const queryElements = document.querySelectorAll('form.mainSearch input[name="query"]');
	var suggestionTexts = [];
	var suggestionTextIndex = 0;
	var lastPerformedSuggestionQuery = '';
	
	const showSuggestions = async (form, input, suggestionShown, query) =>
	{
		if(lastPerformedSuggestionQuery === query) return;
		
		lastPerformedSuggestionQuery = query;
		
		const path = '/searchSuggestions';
		
		if(debug) console.log('Load suggestions for: '+query+' ('+getRelativeMillis()+')');
		
		const suggestions = await request.postURL(path, {term:query});
		
		if(typeof(suggestions.status) === 'number' && suggestions.status < 0) return;
		
		suggestionTexts = [];
		suggestionTexts.push(query);
		suggestionTextIndex = 0;
		
		const suggestionContainer = (new Template('suggestionContainer')).compile();
		
		suggestions.forEach((suggestion, index) =>
		{
			suggestion.index = index;
			const suggestionRow = (new Template('suggestionRow')).compile(suggestion);
			
			suggestionRow.addEventListener('click', event =>
			{
				suggestionTextIndex = index + 1;
				
				const submitEvent = new Event('submit', { cancelable: true });
				
				form.dispatchEvent(submitEvent);
			});
			
			suggestionContainer.appendChild(suggestionRow)
			
			if(suggestion.value === '') suggestion.value = query;
			
			suggestionTexts.push(suggestion.value);
		});
		
		const formParent = form.parentNode;
		suggestionShown = formParent.querySelector(suggestionsShownSelector);
		
		if(suggestionShown !== null)
		{
			if(debug) console.log('Remove old overlay to add new');
			
			suggestionShown.remove();
		}
		
		if(suggestions.length > 0)
		{
			form.parentNode.insertBefore(suggestionContainer, form.nextSibling) // insert after
			
			if(debug) console.log('Suggestions loaded for '+query+' ('+getRelativeMillis()+')');
		}
		else
		{
			if(debug) console.log('Suggestion load skipped; no suggestions');
		}
	};
	
	var disableEventHandlerOnce = false
	var autoSuggestionTimer = null;
	queryElements.forEach((queryElement, index) =>
	{
		queryElement.addEventListener('focus', event =>
		{
			if(window.innerHeight < 620 || getBootstrapDevice() === 'xs')	//header + search results (8+6) should never exceed 620px, but on mobile the keyboard will cover the results so mobile will always scroll
			{
				if(queryElement.parentNode.closest('.logoSearchCart'))	//we only want to scroll to the primary search field
				{
					scrollToElement(queryElement, null, 10);
				}
			}
		});
		
		['keyup', 'change', 'focus'].forEach(eventName =>
		{
			queryElement.addEventListener(eventName, event =>
			{
				const input = event.target;
				const form = input.parentNode.closest('form.mainSearch');
				const formParent = form.parentNode;
				const suggestionShown = formParent.querySelector(suggestionsShownSelector);
				
				if(disableEventHandlerOnce)
				{
					disableEventHandlerOnce = false;
					return;
				}
				
				if(!suggestionsEnabled) return;
				
				if(event.type === 'focus') lastPerformedSuggestionQuery = '';	//because we always want to re-trigger the search when focusing, also if it is the same as the last
				
				const query = input.value;
				const queryLength = query.trim().length;
				
				if(autoSuggestionTimer !== null) clearTimeout(autoSuggestionTimer);
				
				if(queryLength >= 2)	//fix from HK 2017-05-29
				{
					showSuggestions(form, input, suggestionShown, query);
				}
				else if(suggestionShown !== null)
				{
					if(debug) console.log('Query too short: Remove overlay');
					
					suggestionShown.remove();
				}
			});
		});
		
		queryElement.addEventListener('blur', event =>
		{
			const input = event.target;
			const form = input.parentNode.closest('form.mainSearch');
			const formParent = form.parentNode;
			const suggestionShown = formParent.querySelector(suggestionsShownSelector);
			
			if(debug) console.log('Event: blur ('+getRelativeMillis()+')');
			
			if(suggestionShown !== null)
			{
				setTimeout(() =>
				{
					if(debug) console.log('Delayed blur: Remove overlay ('+getRelativeMillis()+')');
					
					suggestionShown.remove();
				}, 800);
			}
		});
		
		queryElement.addEventListener('keydown', event =>
		{
			const input = event.target;
			const form = input.parentNode.closest('form.mainSearch');
			const formParent = form.parentNode;
			const suggestionShown = formParent.querySelector(suggestionsShownSelector);
			
			const pressed = event.keyCode;
			
			const keyCodes =
			{
				backspace:8,
				tab:9,
				enter:13,
				escape:27,
				space:32,
				pageUp:33,
				pageDown:34,
				end:35,
				home:36,
				left:37,
				up:38,
				right:39,
				down:40,
				delete:46,
				comma:188,
				period:190
			};
			
			if(pressed === keyCodes.down)
			{
				if(debug) console.log('Arrow Down');
				
				event.preventDefault();
				
				suggestionTextIndex++;
				if(suggestionTextIndex > suggestionTexts.length-1) suggestionTextIndex = 0;
				
				disableEventHandlerOnce = true;
				
				for(const suggestion of suggestionShown.querySelectorAll('.highlighted')) suggestion.classList.remove('highlighted');
				
				if(suggestionTextIndex > 0) suggestionShown.children[suggestionTextIndex - 1].classList.add('highlighted');
				
				input.value = suggestionTexts[suggestionTextIndex];
			}
			else if(pressed === keyCodes.up)
			{
				if(debug) console.log('Arrow Up');
				
				event.preventDefault();
				
				suggestionTextIndex--;
				if(suggestionTextIndex < 0) suggestionTextIndex = (suggestionTexts.length-1);
				
				disableEventHandlerOnce = true;
				
				for(const suggestion of suggestionShown.querySelectorAll('.highlighted')) suggestion.classList.remove('highlighted');
				
				if(suggestionTextIndex > 0) suggestionShown.children[suggestionTextIndex - 1].classList.add('highlighted');
				
				input.value = suggestionTexts[suggestionTextIndex];
			}
			else if(pressed === keyCodes.escape)
			{
				if(suggestionShown.length > 0)
				{
					if(debug) console.log('Escape: Remove overlay');
					
					suggestionShown.remove();
				}
			}
		});
		
		queryElement.parentNode.closest('form.mainSearch').addEventListener('submit', event =>
		{
			const form = event.target;
			const formParent = form.parentNode;
			const suggestionShown = formParent.querySelector(suggestionsShownSelector);

			const focusedSuggestion = suggestionShown?.children[suggestionTextIndex - 1];

			if(focusedSuggestion === null || focusedSuggestion?.classList.contains('showAllResults'))
			{
				if(debug)
				{
					console.log('"ShowAll" clicked ('+getRelativeMillis()+')');
					
					return;
				}
				
				form.submit();
				
				return true;
			}
			else if(focusedSuggestion?.classList.contains('product') || focusedSuggestion?.classList.contains('product-v2'))
			{
				event.preventDefault();
				
				const url = focusedSuggestion.querySelector('[data-url]').getAttribute('data-url');
				
				if(debug)
				{
					console.log('Product clicked ('+getRelativeMillis()+') ('+url+')');
					
					return;
				}
					
				window.location = url;
			}
			else if(focusedSuggestion?.classList.contains('page'))
			{
				event.preventDefault();
				
				const url = focusedSuggestion.querySelector('[data-url]').getAttribute('data-url');
				
				if(debug)
				{
					console.log('Page clicked ('+getRelativeMillis()+') ('+url+')');
					
					return;
				}
				
				window.location = url;
			}
			
			return false;
		}, true);
		
		queryElement.setAttribute('autocomplete', 'off');
		
		const observer = new window.IntersectionObserver(([entry]) =>
		{
			observer.unobserve(entry.target); // We only want to do it once
			
			// If is visible
			if(entry.isIntersecting) queryElement.focus();
		},
		{
			root: null,
			threshold: 0.1, // set offset 0.1 means trigger if atleast 10% of element in viewport
		});
		
		// Wait for the page to fully load
		setTimeout(() => observer.observe(queryElement), 25);
	});
};

export default searchSuggestions;
